<template>
  <div>
    <v-card class="pl-5 pr-5">
      <div class="row align-center">
        <div class="col">
          <h1>Borrowing History</h1>
        </div>
        <div class="col text-right">
          <v-btn color="primary" @click="openReport">Filter</v-btn>
        </div>
      </div>
      <v-divider></v-divider>
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="pt-2">
        <v-tab-item><LendingOngoing /> </v-tab-item>
        <v-tab-item><LendingCompleted /></v-tab-item>
      </v-tabs-items>
      <LendingReportDialog ref="reportDialog" :isReturned="reportIsReturned" />
    </v-card>
  </div>
</template>

<script>
import LendingOngoing from "./../components/LendingOngoing";
import LendingStatus from "./../components/LendingStatus";
import LendingCompleted from "./../components/LendingCompleted";
import LendingReportDialog from "./../components/LendingReportDialog";

export default {
  name: "Lending",
  components: {
    LendingOngoing,
    LendingStatus,
    LendingCompleted,
    LendingReportDialog
  },
  computed: {
    reportIsReturned() {
      if (this.tab === 0) return false;
      if (this.tab === 1) return true;
      return null; // all
    }
  },
  methods: {
    openReport() {
      this.$refs.reportDialog.open(this.reportIsReturned);
    }
  }
  ,
  data() {
    return {
      tab: null,
      items: ["ONGOING ", "Completed"],
    };
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Lending.vue